export default __webpack_public_path__ + "static/media/CategoryRed.4c984078.png";